import { render, staticRenderFns } from "./AlunosDadosPorTurma.vue?vue&type=template&id=cc0ba47a&scoped=true&"
import script from "./AlunosDadosPorTurma.vue?vue&type=script&lang=js&"
export * from "./AlunosDadosPorTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0ba47a",
  null
  
)

export default component.exports